// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__YE8ME"};